export default __webpack_public_path__ + "static/media/disable3.af78167e.png";